module.exports = __webpack_public_path__ + "static/img/psiloader.459e0ba.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/psiloader.gif
// module id = 7EqT
// module chunks = 1